export const getters = {
  col: (state) => state.col,
  row: (state) => state.row,
  gridConfiguration: (state) => state.gridConfiguration,
  paddingGrid: (state) => state.paddingGrid,
  selectedGridItem: (state) => state.selectGridItem,
  selectedGridItemConfiguration: (state) => state.selectGridItemConfiguration,
  gridTemplateArea: (state) => state.gridTemplateArea,
  selectedMenuForGrid: (state) => state.selectedMenuForGrid,
  cacheData: (state) => state.cache,
  image: (state) => state.image,
  aspectRatio: (state) => state.aspectRatio,
  backgroundImageSizeBehaviour: (state) => state.backgroundImageSizeBehaviour,
  menuGridItemList: (state) => state.menuGridItemList,
  clausesList: (state) => state.clausesList,
  selectedGridItemToDelete: (state) => state.gridItemToDelete,
  openPortal: (state) => state.openPortal,
};
